/**
 * @generated SignedSource<<8daf38891f082b9afdd16b25482544aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HotelSource = "ETG" | "TEDO";
import { FragmentRefs } from "relay-runtime";
export type HotelEditMainGeneral_hotel$data = {
  readonly externalId: string | null;
  readonly source: HotelSource | null;
  readonly " $fragmentType": "HotelEditMainGeneral_hotel";
};
export type HotelEditMainGeneral_hotel$key = {
  readonly " $data"?: HotelEditMainGeneral_hotel$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditMainGeneral_hotel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelEditMainGeneral_hotel",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "type": "Hotel",
  "abstractKey": null
};

(node as any).hash = "5924b1eeec2cce51cc6493a1f8c87d25";

export default node;
